enum ReceivedDefinitionType {
    EVENT_DEFINITIONS = "EVENT_DEFINITIONS",
    ARGUMENT_DEFINITIONS = "ARGUMENT_DEFINITIONS",
}

export default ReceivedDefinitionType;
